import React from "react";

import { InputNumber, Table, Form } from "antd";

class TableTwo extends React.Component {
  state = {
    tableData: [],
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.targetKeys !== this.props.targetKeys ||
      prevProps.applicationValue !== this.props.applicationValue
    ) {
      const { initialValue, formRef } = this.props;
      const result = [];
      if (this.props.targetKeys && this.props.applicationValue) {
        this.props.targetKeys.forEach((e) => {
          const indexesGetDataResult = this.props.indexesGetData.find(
            (a) => e === a._id
          );
          if (indexesGetDataResult) {
            result.push(indexesGetDataResult);
          }
        });
      }
      this.setState({ tableData: result });
    }
  }

  renderTable = () => {
    const { tableData } = this.state;
    const { applicationValue, applicationsGetData, targetKeys } = this.props;
    
    const columns = [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        width: "200px",
      },

    ];

    applicationValue.forEach((selectedValue) => {
      const application = applicationsGetData.find((e) => e._id === selectedValue);
      columns.push(
        {
          title: application.app_name,
          dataIndex: selectedValue,
          key: selectedValue,
          // width: "100px",
          render: (text, record) => (
            <div>
              <Form.Item
                noStyle
                shouldUpdate={(prevValues, currentValues) =>
                  prevValues.custom2?.[selectedValue] !== currentValues.custom2?.[selectedValue]
                }
              >
                {({ getFieldValue }) => (
                  <Form.Item
                    name={["custom2", selectedValue, record._id, "order"]}
                    // initialValue={text ? text : null }
                    style={{ marginBottom: "0px" }}
                    rules={[
                      {
                        validator: (rule, value) => {
                          let returnValidator = false;
                          const custom2Data = getFieldValue("custom2");
                          if (custom2Data && custom2Data[selectedValue]) {
                            for (const [k, a] of Object.entries(custom2Data[selectedValue])) {
                              if (
                                a.order &&
                                value &&
                                a.order === value &&
                                record._id !== k && targetKeys.includes(k)
                              ) {
                                returnValidator = true;
                              }
                            }
                          }
                          if (returnValidator) {
                            return Promise.reject("You can't duplicate order");
                          } else {
                            return Promise.resolve();
                          }
                        },
                      },
                    ]}
                  >
                    <InputNumber min={1} precision={0} />
                  </Form.Item>
                )}
              </Form.Item>
            </div>
          ),
        }
      )


    });

    return (
      <div >
        {applicationValue.length > 0 ? (
          <Table
            dataSource={tableData}
            columns={columns}
            pagination={false}
            rowKey="_id"
            size="small"
          />) : null}
      </div>
    );

  };

  render() {
    return (
      <div>
        {this.renderTable()}
      </div>
    );
  }
}

export default TableTwo;
